import { render, staticRenderFns } from "./LandingPageWidgets.vue?vue&type=template&id=44d53e28&scoped=true"
import script from "./LandingPageWidgets.vue?vue&type=script&lang=js"
export * from "./LandingPageWidgets.vue?vue&type=script&lang=js"
import style0 from "./LandingPageWidgets.vue?vue&type=style&index=0&id=44d53e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d53e28",
  null
  
)

export default component.exports